import Layout from '@/components/feature/Layout';
import HeroCarousel from './components/HeroCarousel';
import MarketBrief from './components/MarketBrief';
import PriceOverview from './components/PriceOverview';
import NewsPreview from './components/NewsPreview';
import TopicSection from './components/TopicSection';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  return (
    <Layout>
      <title>黄金—权威黄金行情与投资指导平台</title>
      <meta
        name="description"
        content="黄金网站为您提供最新黄金价格行情、市场分析及投资资讯，覆盖黄金现货、期货等多种产品，助您科学把握投资机会。"
      />
      <meta
        name="keywords"
        content="黄金,黄金价格,黄金行情,投资黄金,黄金市场,黄金资讯,贵金属,黄金走势"
      />

      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-portal px-4 py-6 md:px-6">
          <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            黄金
          </h1>
          <p className="mt-1.5 text-sm text-foreground-600">
            权威黄金行情与投资指导平台 · 现货 · 期货 · 市场分析 · 投资资讯
          </p>
        </div>
      </div>

      <section className="mx-auto max-w-portal px-4 py-8 md:px-6 md:py-10">
        <div className="grid gap-5 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <HeroCarousel />
          </div>
          <MarketBrief />
        </div>
      </section>

      <PriceOverview />
      <NewsPreview />
      <TopicSection />
      <SiteIntro />
    </Layout>
  );
}